import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { DEFAULT_PAGE_SIZE } from './config/table';
import 'antd/dist/reset.css';
import 'normalize.css';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider locale={zhCN} pagination={{ defaultPageSize: DEFAULT_PAGE_SIZE, showSizeChanger: true }}>
    <App />
  </ConfigProvider>
);
